<template>

  <div :class="['collection-data-wrap']" v-loading="loading || in_sideLoading">

    <header class="top">
      <div class="left">
        <el-button v-for="(item, k) in statusList" :key="k" :type="item.is_selected ? 'normal' : 'text'"
          @click="pickStatus(k)">
          {{ item.text }}
        </el-button>
      </div>
      <div class="ui-search">
        <Search @onenter="search" :placeholder_text="`Search`" />
      </div>
      <div class="right">
        <Dropdown :items="programs" :disabled="is_empty_data || programs.length === 0" class="dropdown-programs"
          @update-dropdown="updateProgram" :is_update_index="true" :spec_drop_filed="'list_tag_open'" :default_value="0"
          :is_select_dropdown="true" :multi_pick="true" :key="tag_f_key" />
        <Dropdown :items="select_pagenum" :disabled="is_empty_data" @update-dropdown="updatePagenum" />
        <Pagenavi :disabled="is_empty_data" :page_current="sort.current_page" :page_total="sort.total_page"
          @goto-page="gotoPage" />
        <RowEditList :data="collectionData">
          <el-button type="primary" :disabled="collectionData.every(e => { return !e.checked })">Edit</el-button>
        </RowEditList>
      </div>
    </header>
    <FilterResults v-if="params.tag.length > 0" :params="params" @update-filter="updateFilter" :key="params" />

    <Scrollbar
      :class="['data-list', (editValue && now_pick_key < 7 && collectionData.length <= 5) && 'data-list-open-scroll']"
      :show_bar="true">
      <Table :style="'--top: 0px'">
        <template #head>
          <tr>
            <th @click.stop="toggleAll">
              <Checkbox :checked="checkAll" />
            </th>
            <th class="name-row"><span>Collection</span></th>
            <TableTh :name="'status'" :title="'Status'" :sort_value="sort" @sort="sortFun" :content="'Status'" />
            <th><span>Recipients</span></th>
            <TableTh :name="'created_at'" :title="'Date Created'" :sort_value="sort" @sort="sortFun"
              :content="'Date Created'" />
            <TableTh :name="'updated_at'" :title="'Last Update'" :sort_value="sort" @sort="sortFun"
              :content="'Last Update'" />
            <th class="svg-th"><span>Actions</span></th>
          </tr>
        </template>

        <template #body>
          <template v-if="collectionData.length === 0">
            <tr>
              <td colspan="7">
                <NoData />
              </td>
            </tr>
          </template>

          <tr v-else v-for="(row, index) in collectionData" :key="index" @click.stop="viewDetail(row)">
            <td @click.stop="checkHandle(row, index)">
              <Checkbox :disabled="!row.canClick" :checked="row.checked" />
            </td>

            <td class="title">
              <div class="title-content">
                <collection-images v-if="row.cover_image_url" :image="row.cover_image_url"
                  :images="row.first_4_product_thumbnails" />
                <img v-else :src="TempImg" class="collection-grid" />
                <div class="middle">
                  <div class="collect-name-box">
                    <div class="collect-name" v-tippy="{ content: row.name, delay: [500, 20] }">
                      {{ row.title? row.title : '---' }}
                    </div>
                    <div class="desc" v-tippy="{ content: row.description, delay: [500, 20] }">{{ row.description }}
                    </div>
                  </div>

                  <div class="bottom">
                    <div class="shop">
                      <svg-icon name="bag" />{{ row.product_count ? row.product_count : 0 }}
                    </div>

                  </div>
                </div>
              </div>
            </td>

            <td>
              <div class="badage-flex">
                <Badage :value="row.statusBag.label" :type="row.statusBag.color" />
                <Badage v-if="row.is_feature" :value="'Featured'" :type="'yellow'" />
              </div>
              
              <div class="date">
                <div class="date-text">{{ row.status == STATUS_CODE.Active || row.status == STATUS_CODE.Disabled  ? `Published: ${formatDate(row.published_at)}`:'' }} </div>
                <div class="date-text">{{ row.status == STATUS_CODE.Scheduled ? `Scheduled: ${formatDate(row.publish_datetime)}`:'' }} </div>
                <div v-if="(row.disable_datetime || row.status == STATUS_CODE.Disabled) && row.status!== STATUS_CODE.Draft" class="date-text">
                  {{ row.status == STATUS_CODE.Disabled ? 'Disabled': 'End Date' }}: {{ row.status == STATUS_CODE.Disabled && row.disabled_at ? formatDate(row.disabled_at) : row.disable_datetime ? formatDate(row.disable_datetime):'---' }}
                </div>

                <div @click.stop="publishCollection(row)" class="pub-text-tip" v-if="row.is_product_changed && (row.status === STATUS_CODE.Active || row.status === STATUS_CODE.Scheduled)">Unpublished changes, <span >publish now</span></div>
              </div>
            </td>

            <td>
              <span class="rec-td" @click.stop="openPostTo(row)">
                <span class="small-badage">
                  <svg-icon name="users-2" />
                  {{ row.recipient_count }}
                </span>
                <svg-icon name="pen" />
              </span>
            </td>

            <td>
              <span class="user-name">{{ row.creator_name }}</span>
              <div class="date-text">
                {{ formatDate(row.created_at, 'MMM DD, YYYY') }}<br>
                {{ formatDate(row.created_at, 'hh:mm A') }} UTC
              </div>
            </td>

            <td>
              <span class="user-name">{{ row.operator_name }}</span>
              <div class="date-text">
                {{ formatDate(row.updated_at, 'MMM DD, YYYY') }}<br>
                {{ formatDate(row.updated_at, 'hh:mm A') }} UTC
              </div>
            </td>

            <td class="menu-td" @click.stop="pickEdit(row, index)">
              <span class="svg-td"><svg-icon name="menu" /></span>
              <div class="editList" v-if="editValue && now_pick_row.id === row.id" :style="editListTopText" ref="el">
                <div class="item" v-for="(item, index) in editList" :key="index"
                  @click.stop="selectType(item.id, index)">
                  <span :class="[(item.id === 9 || item.id === 6) && 'red']">{{ item.text }}</span>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </Table>
    </Scrollbar>


  </div>

</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed, onBeforeUnmount } from 'vue';
import { ElButton } from 'element-plus';
import { useStore } from 'vuex';
import moment from 'moment';
import Table from '@/components/ui/Table.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Badage from '@/components/ui/Badage.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import FilterResults from '@/components/storefront/StorefrontFilterResults.vue';
import CollectionImages from '../ui/CollectionImages.vue';
import { ImageError } from '@/utils/SwitchFun';
import { useStorefrontFunction } from '@/components/storefront/StorefrontFunction.js';
import RowEditList from './RowEditList.vue';
import TempImg from '@/assets/images/no-image.png';
import router from '@/router';

const emit = defineEmits(['isCollectionEmpty'])
const { openRecipientEditDialog, STATUS_CODE, handleStatus, in_sideLoading, saveRecipitentInTable } = useStorefrontFunction();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const store = useStore();
const loading = ref(false);
const collectionData = ref([]);

const select_pagenum = ref([
  { id: 50, text: '50/page' },
  { id: 20, text: '20/page' },
]);
const sort = ref({
  sort_key: 'created_at',
  sort_val: 'desc',
  page: 1,
  per_page: 50,
  search_keyword: '',
  current_page: 1,
  total_page: 1,
});
const params = ref({
  status: '',
  tag: [],
});

const statusList = ref([
  { id: null, text: 'All', is_selected: true, keyword: '' },
  { id: STATUS_CODE.Active, text: 'Active', is_selected: false, keyword: 'active' },
  { id: STATUS_CODE.Draft, text: 'Draft', is_selected: false, keyword: 'draft' },
  { id: STATUS_CODE.Scheduled, text: 'Scheduled', is_selected: false, keyword: 'schedule' },
  { id: STATUS_CODE.Disabled, text: 'Disabled', is_selected: false, keyword: 'disable' },
]);
const is_empty_data = computed(() => {
  return collectionData.value.length === 0;
});
const programs = ref([{ id: 99999999, text: 'All', is_selected: true }]);
const handle_select_cre = ref([]);//remnber last time pick
const tag_f_key = ref(0);//dropdown key

const DROP_LIST = {
  Edit: { id: 1, text: 'Edit info' },
  Feature: { id: 2, text: 'Feature' },
  AddProduct: { id: 3, text: 'Add products' },
  Duplicate: { id: 4, text: 'Duplicate' },
  View: { id: 5, text: 'View details' },
  Disabled: { id: 6, text: 'Disable' },
  UnFeature: { id: 7, text: 'Unfeature' },
  Publish: { id: 8, text: 'Publish collection' },
  Delete: { id: 9, text: 'Delete' },
  ReActive: { id: 10, text: 'Reactivate' },
  PublishChange: { id: 11, text: 'Publish changes' },
};

const editList = ref([]);
const editValue = ref(false);
const now_pick_key = ref(null);
const now_pick_row = ref(null);
const el = ref(null);
//handle edit list dropdown style
const editListTop = ref(0);
const editListTopText = ref('');
const checkAll = ref(false);
//+++++++++++++++++++++++++
const imageError = ImageError;

const canClickItem = (val) => {
  const hasAny = val.cover_image_url && val.title && val.product_count;

  return hasAny;
};

const formatDate = (dateStr, format = 'MMM DD, YYYY hh:mm A') => {
  if (!dateStr) return null;
  return moment(dateStr).format(format);
};

const makeApiStr = () => {
  let filters = [];

  if (params.value.status) {
    filters.push({ "field_name": 'status', "value": params.value.status })
  }

  const selected_program = programs.value.filter(e => e.is_selected);

  if (selected_program.some(p => p.id !== 99999999)) {
    selected_program.forEach(p => {
      filters.push({ field_name: "tag", value: p.id });
    });
  }


  return JSON.stringify(filters);
};

const fetchData = async () => {
  if(loading.value) return;
  
  const params_data = {
    sort_key: sort.value.sort_key,//variants,updated_at
    sort_val: sort.value.sort_val,
    page: sort.value.page,
    per_page: sort.value.per_page,
    filters: makeApiStr(),
    keyword: sort.value.search_keyword,
  };
  try {
    loading.value = true;
    store.state.spec_value.storefrontLoading= true;
    const res = await ajax(`storefront-curation/get-curation-collection-list`, {
      params: params_data,
      method: 'get',
    });

    if(res.data.data.data){

      res.data.data.data.forEach(item => {
        handleStatus(item);
        item.canClick = canClickItem(item);
        item.canDisable = item.status === STATUS_CODE.Active;
      });
    }
    collectionData.value = res.data.data.data?res.data.data.data:[];

    sort.value.total_page = res.data.data.last_page;

    let isNoFilter = params.value.status === '' && sort.value.search_keyword === '';
    if (isNoFilter && collectionData.value.length === 0) {
      emit('isCollectionEmpty', true);
    } else {
      emit('isCollectionEmpty', false);
    }

    const paramsURL = new URLSearchParams(window.location.search);
    let get_Item = window.localStorage.getItem('storefront_collection_detail_row');
    if (paramsURL.has('id') && JSON.parse(get_Item).id === Number(paramsURL.get('id'))) {
      viewDetail(JSON.parse(get_Item));
    }
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
    store.state.spec_value.storefrontLoading= false;
  }

};

const search = (keyword) => {
  sort.value.sort_key = '';
  sort.value.sort_val = 'desc';
  sort.value.search_keyword = keyword;
  handle_select_cre.value = [];
  fetchData();
};

const pickStatus = (index) => {
  statusList.value.forEach((item, idx) => {
    item.is_selected = idx === index;
  });
  params.value.status = statusList.value[index].keyword;
  handle_select_cre.value = [];
  fetchData();
};

const updatePagenum = (obj) => {
  sort.value.per_page = obj.id;
  sort.value.page = 1;
  handle_select_cre.value = [];
  fetchData();
};

const gotoPage = (page) => {
  sort.value.current_page = page;
  sort.value.page = page;
  handle_select_cre.value = [];
  fetchData();
};

//same in creator list
const updateFilter = (obj) => {
  const tagIds = Array.isArray(obj.tag) ? obj.tag.map(t => t.id) : [];

  programs.value.forEach(program => {
    if (tagIds.length === 0) {
      program.is_selected = false;
      
      if (program.id === 99999999) {
        program.is_selected = true;
      };
      handle_select_cre.value = []
      tag_f_key.value += 1;
    } else {

      if (!tagIds.includes(program.id) && program.is_selected) {
        program.is_selected = false;
      }
    }
  });

  params.value = obj;
  handle_select_cre.value = [];
  fetchData();
};

const sortFun = (key) => {
  if (key === sort.value.sort_key) {
    sort.value.sort_val = sort.value.sort_val === 'asc' ? 'desc' : 'asc';
  } else {
    sort.value.sort_key = key;
    sort.value.sort_val = 'asc';
  }
  sort.value.page = 1;
  fetchData();
};

const toggleAll = () => {
  checkAll.value = !checkAll.value;
  collectionData.value.forEach(item => {
    if (item.canClick) {
      item.checked = checkAll.value;
    }
  });

};

const checkHandle = (row, index) => {
  if (!row.canClick) {
    row.checked = false;
  } else {
    row.checked = !row.checked;
  }
  const canClickItems = collectionData.value.filter(item => item.canClick);
  checkAll.value = canClickItems.length > 0 && canClickItems.every(item => item.checked);
};

const getListHadTags = async () => {
  try {
    const res = await ajax('/storefront-curation/get-tag-list', {
      method: 'get',
    });

    programs.value = [
      { id: 99999999, text: 'All', is_selected: true },
    ];
    res.data.data.forEach(item => {
      programs.value.push({
        ...item,
        text: item['tag'],
        is_selected: false,
      });
    });
  } catch (error) {
    console.error('Error fetching tag list:', error);
  }
};

const updateProgram = (obj) => {
  // log('blue',obj);
  const isAll = obj.id === 99999999;
  params.value.tag = [];
  programs.value.forEach(item => {
    //item.is_selected = false;
    if (isAll) {
      if (item.id === 99999999) {
        item.is_selected = true;
      } else {
        item.is_selected = false;
      }
    } else {
      if (item.id === obj.id) {
        item.is_selected = true;
      } else if (item.id === 99999999 && item.is_selected) {
        item.is_selected = false;
      }
    }

    if (item.is_selected && item.id !== 99999999) {
      params.value.tag.push({ id: item.id, text: item.text });
    }
  });

  handle_select_cre.value = [];
  fetchData();
}

const pickEdit = (row, key) => {
  if (row.status === STATUS_CODE.Draft) {

    if (row.canClick) {
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.Publish,
        DROP_LIST.AddProduct,
        DROP_LIST.Delete,
        DROP_LIST.Duplicate,
      ];
    } else {
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.AddProduct,
        DROP_LIST.Delete,
        DROP_LIST.Duplicate,
      ];
    }
  } else if (row.status === STATUS_CODE.Disabled) {
    editList.value = [
      DROP_LIST.Edit,
      DROP_LIST.ReActive,
      DROP_LIST.View,
      DROP_LIST.Duplicate,
    ];
  }
  else if (row.status === STATUS_CODE.Scheduled) {
    editList.value = [
      DROP_LIST.Edit,
      DROP_LIST.Publish,
      DROP_LIST.AddProduct,
      DROP_LIST.View,
      DROP_LIST.Duplicate,
    ];
  } else if (row.status === STATUS_CODE.Active) {
    if (row.is_feature) {
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.AddProduct,
        DROP_LIST.UnFeature,
        DROP_LIST.Duplicate,
        DROP_LIST.View,
        DROP_LIST.Disabled,
      ];
    } else {
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.AddProduct,
        DROP_LIST.Feature,
        DROP_LIST.Duplicate,
        DROP_LIST.View,
        DROP_LIST.Disabled,
      ];
    }
    if(row.is_product_changed){
      editList.value.splice(editList.value.length - 1, 0, DROP_LIST.PublishChange);
    }
  } else {
    editList.value = [];
  }

  //-------permission

  //----------------

  editValue.value = now_pick_key.value === key && editValue.value ? false : true;//控制開關
  now_pick_row.value = row;
  now_pick_key.value = key;

  if (key <= 3) {
    editListTop.value = 32;
    editListTopText.value = `top:${editListTop.value}px`;
  } else {
    editListTop.value = 20;
    editListTopText.value = `bottom:${editListTop.value}px`;
  }

};

const publishCollection = (val) => {
  now_pick_row.value = val;
  editValue.value = false;
  const aId = now_pick_row.value.id;

  eventBus.emit('open-storefront-collection-handle-dialog', {
    type: now_pick_row.value.is_schedule ? 'PublishSchedule' :now_pick_row.value.status === STATUS_CODE.Draft && now_pick_row.value.publish_datetime ?'PublishDraftToSchedule': 'Publish',
    data: [now_pick_row.value]
  });
};

const handleClick = (e) => {

  const elements = el.value;
  let isOutside = true;

  // $refs.el v-for 
  if (Array.isArray(elements)) {
    for (let el of elements) {
      if (el.contains(e.target)) {
        isOutside = false;
        break;
      }
    }
  }

  if (isOutside) {
    editValue.value = false;
  }
};

const selectType = (id, index) => {
  editValue.value = false;
  const aId = now_pick_row.value.id;

  switch (id) {
    case 1:
      // edit
      eventBus.emit('open-collection-edit-dialog', { id: 1, row: now_pick_row.value, which: 'collection' });//done
      break;

    case 2:
      // feature
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: 'Feature',
        data: [now_pick_row.value]
      });
      break;

    case 3:
      // tag products to collection
      viewDetail(now_pick_row.value);
      eventBus.emit('tag-products', { id: aId, which: 'collection', row: now_pick_row.value });
      break;

    case 4:
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: 'Duplicate',
        data: [now_pick_row.value]
      });
      break;

    case 5:
      viewDetail(now_pick_row.value);
      break;

    case 6:
      // diasbled->only publish active can disabled
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: 'Disabled',
        data: [now_pick_row.value]
      });
      break;

    case 7:
      // Unfeature
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: 'Unfeature',
        data: [now_pick_row.value]
      });
      break;
    case 8:
      // Publish
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: now_pick_row.value.is_schedule ? 'PublishSchedule' :now_pick_row.value.status === STATUS_CODE.Draft && now_pick_row.value.publish_datetime ?'PublishDraftToSchedule': 'Publish',
        data: [now_pick_row.value]
      });
      break;
    case 9:
      // delete
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: 'Delete',
        data: [now_pick_row.value]
      });
      break;
    case 10:
      // reactivate
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: (now_pick_row.value.is_schedule || now_pick_row.value.publish_datetime) ? 'PublishSchedule' : 'Publish',
        data: [now_pick_row.value]
      });
      break;
    case 11:
      // pub change
      eventBus.emit('open-storefront-collection-handle-dialog', {
        type: (now_pick_row.value.is_schedule || now_pick_row.value.publish_datetime) ? 'PublishSchedule' : 'Publish',
        data: [now_pick_row.value]
      });
      break;

    default:
      break;
  }
};

const openPostTo = async (row) => {
  row.click_all = row.apply_to_all_creators;
  const result = await openRecipientEditDialog(row);
  if (result) {
    await saveRecipitentInTable(result, 'collection');
    fetchData();
  }

};

const viewDetail = (row) => {
  eventBus.emit('open-collection-detail', {
    content_id: row.id,
    is_edit: false,
    row: row //mp new
  });
  window.localStorage.setItem('storefront_collection_detail_row', JSON.stringify(row));
  const newUrl = `${location.pathname}?id=${row.id}`;
  history.replaceState(null, '', newUrl); 
}
//++++++++
//++++++++++++++++++++++++
onMounted(async () => {
  fetchData();
  await getListHadTags();
  window.addEventListener('click', handleClick);
  eventBus.on('refresh-storefront-collection-table', () => {
    fetchData();
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('click', handleClick);
  eventBus.off('refresh-storefront-collection-table');
});

</script>
<style lang="scss">
.collection-data-wrap {
  .tag-flex-box {
    svg {
      width: 10px !important;
      height: 10px !important;
    }
  }

  tr {
    cursor: pointer;
  }

  th{
    .sort{
      display: flex !important;
    }
  }

  .pub-text-tip{
    padding: 6px 0;
    span{
      color: var(--blue);
    }
  }

}
</style>